export enum FeatureFlags {
  PropertiesMenu = 'ENI-889',
  AskAI = 'ENI-978',
  AiTemplateEpisodes = 'ENI-1042',
  GenerateImagesWithAi = 'ENI-1048',
  UseFunctionForFlowSave = 'ENI-1040',
  ShowUndoRedoInSidebar = 'ENI-911',
}
